module.exports = "﻿﻿<div class=\"wrapper wrapper-content animated fadeInRight\">\r\n    <div class=\"row\">\r\n        <div class=\"col-lg-12\">\r\n            <div class=\"ibox float-e-margins\" *ngIf=\"pageContent\">\r\n                <div [innerHtml]=\"pageContent | safeHtml\">\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/competitors/competitor.help.component.html
// module id = 1550
// module chunks = 0